import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 3.33333C10.7953 3.33333 3.33333 10.7953 3.33333 20C3.33333 29.2047 10.7953 36.6667 20 36.6667C29.2047 36.6667 36.6667 29.2047 36.6667 20C36.6667 10.7953 29.2047 3.33333 20 3.33333ZM25.9674 16.6249C26.4046 16.0906 26.3259 15.303 25.7915 14.8659C25.2572 14.4287 24.4697 14.5075 24.0326 15.0418L17.4072 23.1394L15.0505 20.7828C14.5624 20.2946 13.7709 20.2946 13.2828 20.7828C12.7946 21.2709 12.7946 22.0624 13.2828 22.5506L16.6161 25.8839C16.8658 26.1336 17.2095 26.266 17.5623 26.2484C17.915 26.2309 18.2438 26.0649 18.4674 25.7915L25.9674 16.6249Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgStatusCheck;
